<ax-value-edit
  type="TEXT"
  [form]="valueForm"
  [name]="name"
  [autofocus]="autofocus"
  [label]="label"
  [hint]="hint"
  [required]="required"
  [icon]="showIcon ? customIcon ?? 'hash' : undefined"
  [errorsTemplate]="errorsTemplate"
  [readonly]="readonly && !hashedValue"
  [enableValidation]="enableValidation"
  [subscriptSizing]="subscriptSizing"
></ax-value-edit>

<ng-template #errorsTemplate>
  <ax-property-error [form]="form" [label]="label"></ax-property-error>
  <div class="c-property-edit__error" *ngIf="valueForm?.hasError('invalid-hashed-value')">
    <ax-icon class="icon" name="alert-circle"></ax-icon>
    <span>{{ 'proposal.custom-property.invalid-hashed-value' | translate }}</span>
  </div>
</ng-template>
